import { ImageColumnData } from "@/types/pages/blocks"
import ImageContent from "./Image/ImageContent"

export default function ImageColumn(props: ImageColumnData) {
  const { asset, title, subtitle, button } = props

  return (
    <div className="relative w-full min-h-[360px] flex flex-col group rounded-lg overflow-hidden">
      <div
        className="flex-1 relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${asset?.preview})` }}>
        <div className="absolute inset-0 bg-black/40 h-full">
          <ImageContent title={title} subtitle={subtitle} button={button} />
        </div>
      </div>
    </div>
  )
}
